module.exports = __webpack_public_path__ + "static/media/discover-card.31d7b39e.svg";